import { TypedDocumentNode, gql } from '@apollo/client';

import useQuery from 'hooks/graphql/useQuery';

import {
  NextFixturesProbablePitchersSlugs,
  NextFixturesProbablePitchersSlugsVariables,
} from './__generated__/useNextFixtureProbablePitchersSlugs.graphql';

const NEXT_FIXTURES_PROBABLE_PITCHERS_QUERY = gql`
  query NextFixturesProbablePitchersSlugs {
    config {
      id
      so5 {
        id
        probablePitchersForNextGameWeeks {
          slug
          endDate
          startDate
          gameWeek
          playerSlugs
        }
      }
    }
  }
` as TypedDocumentNode<
  NextFixturesProbablePitchersSlugs,
  NextFixturesProbablePitchersSlugsVariables
>;

export const useNextFixtureProbablePitchersSlugs = (skip: boolean) => {
  const { data, loading } = useQuery(NEXT_FIXTURES_PROBABLE_PITCHERS_QUERY, {
    skip,
    nextFetchPolicy: 'cache-first',
  });

  return {
    probablePitchersForNextGameWeeks:
      data?.config.so5.probablePitchersForNextGameWeeks,
    loading,
  };
};
